// extracted by mini-css-extract-plugin
export default {"headingTop":"Search_headingTop__B3qYt","buttonWrapper":"Search_buttonWrapper__bPr1l","button":"Search_button__JcYfT"};